<div class="configuration-summary__table">
  <button
    (click)="menageTabs(tabsOpened.length)">
    {{openedTabsIndex === products.length ? 'Collapse all' : 'View all'}}
  </button>
  <div class="accordion">
    @for (product of products; track product) {
      <app-accordion
        [manualOpen]="tabsOpened.includes(product.name)">
        <ng-container ngProjectAs="[slot][header]">
          <h2
            class="accordion__title icon-arrow-down"
            aria-controls="panel1"
            aria-expanded="false"
            (click)="toggleTab(product.name)">
            {{ product.name }}
          </h2>
        </ng-container>
        <ng-container ngProjectAs="[slot][panel]">
          <div class="container accordion__content">
            @for (item of product.details; track item) {
              <div class="details">
                <span>{{ item.name }}</span>
                <span class="dotted-line"></span>
                @if (item.price) {
                  <span>{{ item.price | currency: undefined: undefined: 0 }}</span>
                } @else {
                  <span class="icon-check icon-check__circle"></span>
                }
              </div>
            }
          </div>
        </ng-container>
      </app-accordion>
    }
  </div>
</div>
